import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'


const OPTIONS = [
    { label: 'Date range', value: 'range' },
    { label: 'Specific dates', value: 'specific' }
]

export default function SelectCalendarType({ ...props }) {
    const myProps = {
        placeholder: 'Calendar type',
        firstSelect: true, 
        isClearable: false, 
        options: OPTIONS,
        icon: { icon: 'calendar' },
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}